// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18357": "70fb16f8c80d","49663": "961b1003997e","55551": "22fa3bd32107","65956": "f051f49c64e9","66863": "c939bdd77392","72378": "5489a27f0a93",}[chunkId] + ".css"
}